import {Alert, Button, Divider, Modal, notification, Result, Spin, Upload} from "antd";
import React, {useContext, useEffect, useState} from "react";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import AuthContext from "../utilis/contexts/AuthContext";
import AppContext from "../utilis/contexts/AppContext";
import InfiniteScroll from "react-infinite-scroll-component";
import {MdOutlinePayment,MdShowChart} from "react-icons/md"
import {CiSquareQuestion} from "react-icons/ci"
import {TfiWrite} from "react-icons/tfi"
import {
    DownloadOutlined,
    FrownOutlined,
    InboxOutlined,
    PictureOutlined,
    PlusOutlined,
    UploadOutlined
} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import LocalStorage from "../utilis/tools/LocalStorage";
import {UploadProps} from "antd/es/upload/interface";
import {getBase64} from "../utilis/helpers/imageHelper";

const MyRequests = () => {
    const Token=LocalStorage.getToken();
    const navigate=useNavigate();
    const authContext = useContext(AuthContext)
    const appContext = useContext(AppContext)
    const [requests, setRequests] = useState<Array<object>>([]);
    const [CommitmentLoading,setCommitmentLoading]=useState(true);
    const [uploadLoading,setUploadLoading]=useState(false);
    const [uploadFile,setUploadFile]=useState<any>(null);
    const [uploadResult,setUploadResult]=useState<any>(null);
    const [Commiment,setCommiment]=useState<any>(null);
    const [CommitmentModal,setCommitmentModal]=useState(false);
    const [currentTraceNumber,setCurrentTraceNumber]=useState('');
    const [state, setState] = useState<any>({
        items: [],
        hasMore: false
    })
    useEffect(() => {
        if (requests.length) {
            setState({
                items: requests.slice(0, 10),
                hasMore: requests.length > 10
            })
        }
    }, [requests]);
    const CommimentProps: UploadProps = {
        onRemove: file => {
            setUploadFile('')
        },
        beforeUpload: file => {
            getBase64(file).then(base64=>{
                setUploadFile(base64)
            })
            return false;
        },
    };
    const handleUploadFile=()=>{
        setUploadLoading(true);
        setUploadResult(null)
        const data={
            Cellphone:authContext.user.cellphone,
            TraceNumber:currentTraceNumber,
            BillId:authContext.currentBranchInfo.bill_id,
            LegalFacilitiesPic:uploadFile,
            Id:Commiment.id
        }
        Api.post('/UploadLegalFacilitiesFile', data, {
            headers: {
                "Authorization": Token.token_type + " " + Token.access_token,
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if(res.data.Status===0){


                setUploadResult({
                    status:'success',
                    text:res.data.Message
                })
            }else {
                setUploadResult({
                    status:'error',
                    text:res.data.Message
                })
            }
        }).catch(e => {
            setUploadResult({
                status:'error',
                text:'ارسال فایل با خطا مواجه شده است'
            })
        }).finally(()=>{
            setUploadLoading(false)
        })

    }
    const fetchMoreData = () => {
        if (!state.hasMore) {
            return;
        }
        
        setTimeout(() => {
            setState({
                items: state.items.concat(requests.slice(state.items.length, state.items.length + 10 > requests.length ? requests.length : state.items.length + 10)),
                hasMore: state.items.length + 10 < requests.length
            });
        }, 1000);
    };
    const handleWorkFlow=(traceNumber:string)=>{
        navigate('/panel/Workflow', { state: { TraceNumber: traceNumber, BillId:authContext.currentBranchInfo.bill_id,Cellphone:authContext.user.cellphone } });
    }
    const handleCommitment=(traceNumber:string)=>{
        setCurrentTraceNumber(traceNumber);
        setUploadResult(null);
        setUploadResult('');
        setUploadLoading(false)
        setCommitmentLoading(true);
        setCommiment(null);
        setCommitmentModal(true);
        const data={
            Cellphone:authContext.user.cellphone,
            TraceNumber:traceNumber,
            BillId:authContext.currentBranchInfo.bill_id,
        }
        Api.post('/GetLegalFacilitiesFile', data, {
            headers: {
                "Authorization": Token.token_type + " " + Token.access_token,
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if(res.data.Status===-1){
                setCommitmentModal(false);
                notification['error']({
                    message: 'نا موفق',
                    description: res.data.Message,
                    duration: 120
                });
            }else {
                setCommiment(res.data.Data.value);
            }
        }).catch(e => {
            /*setCommitmentModal(false);*/
            console.log(e)
         /*   notification['error']({
                message: 'نا موفق',
                description: 'درخواست نا موفق بوده است',
                duration: 120
            });*/
        }).finally(()=>{
            setCommitmentLoading(false)
        })

    }
    const handleTrackPaymentBills=(traceNumber:string)=>{
        navigate('/panel/TrackPaymentBills', { state: { TraceNumber: traceNumber, BillId:authContext.currentBranchInfo.bill_id,Cellphone:authContext.user.cellphone } });
    }
    const handleCloseModal=()=>{
        setCurrentTraceNumber('');
        setUploadResult(null);
        setUploadFile('')
        setUploadLoading(false)
        setCommitmentLoading(true);
        setCommiment(null);
        setCommitmentModal(false);
    }
    useEffect(() => {

        if (Token) {
            appContext.handleLoading(true)

            Api.post(Urls.getUserRequests, {
                Cellphone: authContext.user.cellphone,
            }, {
                headers: {
                    "Authorization": Token.token_type + " " + Token.access_token
                }
            }).then((response: AxiosResponse) => {

                const {data} = response;
                const {Data} = data;
                const {requests} = Data;
                setRequests(requests)
                
            }).catch((e: AxiosError) => {

            }).finally(() => {

                appContext.handleLoading(false)


            })
        }
    }, [])
    return <>
        <Divider><h3 className="font-bold ">درخواست های من</h3></Divider>
        <InfiniteScroll
            dataLength={state.items.length}
            next={fetchMoreData}
            hasMore={state.hasMore}
            loader={<div className="flex w-full mb-3 justify-center"><Spin/></div>}

        >
            {state.items.map((i: any, index: number) => (
                <div className="bg-gray-50 border-gray-200 border-2 w-full mb-3 mb-2 gap-4 rounded-lg p-4 " key={index}>
                    <div className="w-full mb-3 flex justify-between items-center">
                        <span className="whitespace-nowrap text-sm">نام سرویس</span>
                        <div className="md:w-full  border-t border-dashed border-gray-300   mx-3"/>
                        <span className="whitespace-nowrap text-sm">{i.service_name}</span>
                    </div>
                    <div className="w-full mb-3 flex justify-between items-center">
                        <span className="whitespace-nowrap text-sm">نام مستعار</span>
                        <div className="md:w-full  border-t border-dashed border-gray-300   mx-3"/>
                        <span className="whitespace-nowrap text-sm">{i.alias}</span>
                    </div>
                    <div className="w-full mb-3 flex justify-start items-center">
                        <span className="whitespace-nowrap text-sm">کد رهگیری</span>
                        <div className="w-full  border-t border-dashed border-gray-300   mx-3"/>
                        <span className="whitespace-nowrap text-sm">{i.trace_number}</span>
                    </div>
                    <div className="w-full mb-3 flex justify-between items-center">
                        <span className="whitespace-nowrap text-sm">شماره پرونده</span>
                        <div className="w-full  border-t border-dashed border-gray-300   mx-3"/>
                        <span className="whitespace-nowrap text-sm">{i.file_number}</span>
                    </div>
                    <div className="w-full mb-3 flex justify-between items-center">
                        <span className="whitespace-nowrap text-sm">تاریخ درخواست</span>
                        <div className="w-full  border-t border-dashed border-gray-300  mx-3"/>
                        <span className="whitespace-nowrap text-sm">{i.requested_at}</span>
                    </div>
                    <div className=" flex-wrap gap-3 flex justify-center items-start ">
                        <button onClick={()=>handleWorkFlow(i.trace_number)} className="flex text-primary hover:bg-primary hover:text-white flex-col text-lg justify-center items-center   rounded-lg p-2">
                            <CiSquareQuestion className=" text-lg"/>
                            <span className="text-xs">پیگیری درخواست</span></button>

                        <button onClick={()=>handleTrackPaymentBills(i.trace_number)} className="flex text-primary hover:bg-primary hover:text-white flex-col text-lg justify-center items-center  rounded-lg p-2">
                            <MdOutlinePayment className=" text-lg"/>
                            <span className="text-xs">پیگیری پرداخت</span></button>
                       {/* <button className="flex text-primary hover:bg-primary hover:text-white flex-col text-lg justify-center items-center rounded-lg p-2">
                            <MdShowChart className=" text-lg"/>
                            <span className="text-xs">قبض علی الحساب</span></button>
                        */}
                        <button  onClick={()=>handleCommitment(i.trace_number)} className="flex  text-primary hover:bg-primary hover:text-white flex-col text-lg justify-center items-center rounded-lg p-2">
                            <TfiWrite className=" text-lg"/>
                            <span className="text-xs w-[120px]">دریافت و ارسال فایل تعهد نامه غیر مجاز</span></button>
                    </div>
                </div>
            ))}
        </InfiniteScroll>
        {!requests.length && !appContext.isLoading && <Result
            icon={<FrownOutlined />}
            subTitle="هیچ درخواستی یافت نشد."

        />}
        <Modal open={CommitmentModal} onCancel={handleCloseModal}
               title="دریافت و ارسال فایل تعهد نامه غیر مجاز" footer={''}
               okText={'ذخیره'} cancelText={'بستن'}>
            {!CommitmentLoading && Commiment && <div className="p-3 border-2 grid grid-cols-1 md:grid-cols-2 gap-4 rounded-xl border-dashed ">
                <div><strong className="text-sm">نام : </strong><span>{Commiment.first_name+" "+Commiment.last_name}</span></div>
                <div><strong className="text-sm">نوع سرویس : </strong><span>{Commiment.service_type}</span></div>
                <div><strong className="text-sm">تاریخ درخواست : </strong><span>{Commiment.requested_at}</span></div>
                {Commiment.pic &&     <a className="" href={Urls.PublicRoot+Commiment.pic} download><Button   type="primary" className="  ">دانلود فایل</Button></a>}

            </div>}
            {!CommitmentLoading && Commiment && <div className="p-3 border-2 mt-3 justify-center items-center  flex flex-col   rounded-xl border-dashed ">
                {!uploadLoading && uploadResult && <>
                    <Alert showIcon className="w-full" description={uploadResult.text}  type={uploadResult.status}/>
                    {uploadResult.status==='error' && <Divider/>}
                </>}
                {!uploadLoading && uploadResult.status!=='success' && <>
                <span>ارسال فایل تعهد نامه</span>
                <Upload className="flex justify-center flex-col mt-5 items-center" accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} {...CommimentProps} listType="picture"  maxCount={1} >
                   <Button type="dashed" className="w-full" >انتخاب فایل</Button>
                </Upload>
                {uploadFile!='' && <Button onClick={handleUploadFile} type="primary" className="mt-2 " >ارسال فایل </Button>}

                </>}
                {uploadLoading && <>
                    <Spin size="default"/>
                    <p className="text-sm font-light">در حال ارسال فایل .لطفا منتظر بمانید..</p>
                </>}

            </div>}

            {CommitmentLoading && <div className="flex justify-center">
                <Spin size="large"/>
            </div>}
        </Modal>
    </>
}
export default MyRequests;